import { render, staticRenderFns } from "./ad-placement.vue?vue&type=template&id=3a97ec27&scoped=true&"
import script from "./ad-placement.vue?vue&type=script&lang=js&"
export * from "./ad-placement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a97ec27",
  null
  
)

export default component.exports